module.exports = __webpack_public_path__ + "img/role.2a13cad5.png";